/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ReferralState {
  LEAD_DENIED = "LEAD_DENIED",
  LEAD_QUALIFIED = "LEAD_QUALIFIED",
  LEAD_SELLER_FLOW_INCOMPLETE = "LEAD_SELLER_FLOW_INCOMPLETE",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  OFFER_ASSESSMENTS_COMPLETED = "OFFER_ASSESSMENTS_COMPLETED",
  OFFER_CLOSED = "OFFER_CLOSED",
  OFFER_CONTINGENCIES_RELEASED = "OFFER_CONTINGENCIES_RELEASED",
  OFFER_EXPIRED = "OFFER_EXPIRED",
  OFFER_EXPIRING_SOON = "OFFER_EXPIRING_SOON",
  OFFER_IN_CONTRACT = "OFFER_IN_CONTRACT",
  OFFER_SENT = "OFFER_SENT",
  OFFER_VIEWED = "OFFER_VIEWED",
  OFFER_WITHDRAWN = "OFFER_WITHDRAWN",
  UNKNOWN = "UNKNOWN",
}

export enum SlackChannel {
  SIGN_UP = "SIGN_UP",
}

export enum TourRequestState {
  CANCELED = "CANCELED",
  COMPLETE = "COMPLETE",
  NO_SHOW = "NO_SHOW",
  REQUESTED = "REQUESTED",
  SCHEDULED = "SCHEDULED",
}

export interface NotificationPreferenceInput {
  categoryKey: string;
  enabled: boolean;
}

export interface PartnerUserInput {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string | null;
  roles: string[];
  partnerIdentifier: string;
  regionIdentifier?: string | null;
}

export interface RefreshOfferInput {
  sellerInputId: string;
}

export interface SearchReferralsInput {
  cursor?: string | null;
  state?: ReferralState | null;
  size?: number | null;
}

export interface SlackMessageField {
  title: string;
  value: string;
}

export interface UpdateUserNotificationPreferencesInput {
  userId?: string | null;
  notificationPreferences: NotificationPreferenceInput[];
}

//==============================================================
// END Enums and Input Objects
//==============================================================
